import { motion } from "framer-motion";
import { principles } from "@/data/site";
import { EASE, Eyebrow, Reveal } from "../site/motion";

export default function WhyBytevora() {
  return (
    <section data-testid="why-bytevora-section" className="bg-white py-24 md:py-32">
      <div className="mx-auto grid w-full max-w-[1200px] gap-14 px-6 md:px-8 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-28">
            <Reveal>
              <Eyebrow>Why Bytevora</Eyebrow>
              <h2 className="mt-5 text-3xl font-bold leading-[1.08] tracking-[-0.02em] text-slate-900 md:text-[2.6rem]">
                Engineering beyond delivery.
              </h2>
              <p className="mt-5 max-w-md text-sm leading-relaxed text-slate-600 md:text-base">
                We approach technology as a long-term business asset — not just something that
                needs to be launched.
              </p>
            </Reveal>
          </div>
        </div>

        <div className="lg:col-span-7">
          {principles.map((p, i) => (
            <motion.div
              key={p.title}
              data-testid={`principle-${i + 1}`}
              initial={{ opacity: 0, x: 28 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, ease: EASE, delay: i * 0.06 }}
              className={`group grid grid-cols-[56px_1fr] gap-5 border-t border-slate-200 py-8 transition-colors duration-300 hover:bg-slate-50/70 md:grid-cols-[88px_1fr_1.1fr] md:gap-8 md:px-4 ${
                i === principles.length - 1 ? "border-b" : ""
              }`}
            >
              <span className="pt-1 font-mono text-sm tracking-[0.16em] text-slate-300 transition-colors duration-300 group-hover:text-blue-600">
                /0{i + 1}
              </span>
              <h3 className="text-xl font-semibold tracking-tight text-slate-900">{p.title}</h3>
              <p className="col-span-2 pl-[76px] text-sm leading-relaxed text-slate-600 md:col-span-1 md:pl-0 md:pt-0.5">
                {p.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
